export var Opacity;
(function (Opacity) {
    Opacity["OPACITY_UNKNOWN"] = "OPACITY_UNKNOWN";
    Opacity["OPACITY_NONE"] = "OPACITY_NONE";
    Opacity["OPACITY_5"] = "OPACITY_5";
    Opacity["OPACITY_20"] = "OPACITY_20";
    Opacity["OPACITY_30"] = "OPACITY_30";
    Opacity["OPACITY_40"] = "OPACITY_40";
    Opacity["OPACITY_50"] = "OPACITY_50";
    Opacity["OPACITY_100"] = "OPACITY_100";
})(Opacity || (Opacity = {}));
